module.exports = __webpack_public_path__ + "media/question4_au.177a2a68.mp3";